import React from 'react'
import { useAuthContext } from '@app/components/providers/auth'
import { HistoryList } from '@app/components/paginated/history'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { ProfileInputCell } from '../general/cells/profile-input'
import { User } from '@app/types'

export const HistoryView = ({
  user,
  loading,
}: {
  user?: User
  loading?: boolean
}) => {
  const { t } = useTranslation('settings')
  const { account } = useAuthContext()
  const { activeSubscription } = account ?? {}

  return (
    <ProfileInputCell
      title={t('history')}
      skeletonLoad={!user && loading}
      disabledWall={!activeSubscription}
      submitLabel={{
        title: t(activeSubscription ? 'history-details' : 'history-upgrade'),
      }}
    >
      {activeSubscription ? (
        <div className={'h-32 overflow-y-auto'}>
          <HistoryList />
        </div>
      ) : null}
    </ProfileInputCell>
  )
}
